module.exports = __webpack_public_path__ + "img/leaflet.dc50fb7a.png";